// hooks/useTableHeight.js
import {useCallback, useEffect, useRef, useState} from 'react';

export const useTableHeight = (footerHeight = 80, minHeight = 200) => {
  const [tableHeight, setTableHeight] = useState(600);
  const containerRef = useRef();

  const updateTableHeight = useCallback(() => {
    if (containerRef.current) {
      const windowHeight = window.innerHeight;
      const containerTop = containerRef.current.getBoundingClientRect().top;
      const availableHeight = windowHeight - containerTop - footerHeight;
      setTableHeight(availableHeight > minHeight ? availableHeight : minHeight);
    }
  }, [footerHeight, minHeight]);
    
  useEffect(() => {
        
    updateTableHeight();

    window.addEventListener('resize', updateTableHeight);
    return () => window.removeEventListener('resize', updateTableHeight);
  }, [updateTableHeight]);

  return { tableHeight, containerRef };
};